import { jsx as _jsx } from "react/jsx-runtime";
import { H5 } from 'syf-component-library/ui/typography';
const IntroHeading = ({ as = 'h2', children, dataCy = 'intro-heading', weight }) => {
    return (_jsx(H5, Object.assign({ as: as, "data-cy": dataCy, weight: weight }, { children: children })));
};
export default IntroHeading;
